const STATUS_CONFIG = {
  // Job statuses
  ativa: { label: "Ativa", classes: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  pausada: { label: "Pausada", classes: "bg-amber-50 text-amber-700 border-amber-200" },
  encerrada: { label: "Encerrada", classes: "bg-slate-100 text-slate-600 border-slate-200" },
  // Candidate statuses
  pendente: { label: "Pendente", classes: "bg-amber-50 text-amber-700 border-amber-200" },
  analisado: { label: "Analisado", classes: "bg-blue-50 text-blue-700 border-blue-200" },
  erro: { label: "Falha na análise", classes: "bg-red-50 text-red-700 border-red-200" },
  contatado: { label: "Contatado", classes: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  em_entrevista: { label: "Em entrevista", classes: "bg-violet-50 text-violet-700 border-violet-200" },
  aprovado: { label: "Aprovado", classes: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rejeitado: { label: "Rejeitado", classes: "bg-red-50 text-red-700 border-red-200" },
};

const StatusBadge = ({ status }) => {
  const cfg = STATUS_CONFIG[status] || {
    label: status || "—",
    classes: "bg-slate-100 text-slate-600 border-slate-200",
  };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${cfg.classes}`}
    >
      {cfg.label}
    </span>
  );
};

export default StatusBadge;
